import * as types from '../redux/constants/index';
import handle from '../utilities/errorHandler';
import { saveCapsule as save, getAll, getCount } from '../api/api';
import debug from "debug";

const output = debug('capsule');

export const saveCapsule = (formData) => async (dispatch) => {
    output('Form data: ', formData);

    try {
        const response = await save(formData);
        const { data } = response;
        output('Response data: ', data);

        dispatch({
            type: types.SAVE_CAPSULE,
            payload: data.capsule
        })
    } catch (error) {
        output("ERROR: ", error);
        handle(error, dispatch);
    }
}

export const getAllCapsules = async (dispatch) => {
    try {
        const response = await getAll();
        const { data } = response;
        
        dispatch({
            type: types.GET_ALL,
            payload: data
        })
    } catch (error) {
        output("ERROR", error);
    }

}

export const updateCapsuleCount = async (dispatch) => {
    try {
        const response = await getCount();
        const { data } = response;

        dispatch({
            type: types.CAPSULE_COUNT,
            payload: data
        })
    } catch (error) {
        output("ERROR", error);
    }
}